export default {
  PERCENTAGE: 'percentage',
  MONEY: 'money',
};
